import {Modal} from "antd";
import styled from "styled-components";

export const VisualQaShell = styled.main`
  min-height: 100vh;
  padding: 2.4rem;
  background: #f7f5f8;

  @media (max-width: 760px) {
    padding: 1.2rem;
  }
`;

export const BuilderHeader = styled.header`
  margin-bottom: 2.4rem;

  h1 {
    margin: 0;
    color: #1c1726;
    font-size: 2.4rem;
    font-weight: 700;
    line-height: 3.2rem;
  }
`;

export const BuilderCommandBar = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.6rem;
  margin-bottom: 1.6rem;
  padding: 1.6rem;
  border-radius: 1.6rem;
  background: #ffffff;

  .device-switch {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.4rem;
    border-radius: 1rem;
    background: #f5f5f5;
  }

  .device-switch .ant-btn {
    display: grid;
    width: 2.8rem;
    min-width: 2.8rem;
    height: 2.8rem !important;
    min-height: 2.8rem !important;
    padding: 0 !important;
    place-items: center;
    border: 0;
    border-radius: 0.8rem !important;
  }

  .device-switch .ant-btn-default {
    background: #ffffff;
    box-shadow: 0 0.4rem 1rem rgba(0, 7, 9, 0.08);
  }

  .command-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 1.6rem;
  }

  .mobile-more-button {
    display: none !important;
  }

  .command-actions .ant-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.6rem;
    height: 4.2rem !important;
    min-height: 4.2rem !important;
    padding: 0 1.4rem !important;
    border-color: #ebebeb;
    border-radius: 1rem !important;
    font-size: 1.4rem !important;
    font-weight: 600;
  }

  .command-button-icon {
    display: block;
    flex: 0 0 auto;
    object-fit: contain;
  }

  .command-button-icon.preview-icon {
    width: 1.5rem;
    height: 1.5rem;
  }

  .command-button-icon.share-icon {
    width: 1.2rem;
    height: 1.2rem;
  }

  .command-button-icon.publish-icon {
    width: 1.2rem;
    height: 1.7rem;
  }

  @media (max-width: 760px) {
    align-items: center;
    flex-direction: row;
    margin-bottom: 1.6rem;
    padding: 1.2rem;

    .device-switch {
      align-self: flex-start;
    }

    .command-actions {
      display: flex;
      margin-left: auto;
      gap: 0.8rem;
    }

    .command-actions .ant-btn {
      justify-content: center;
    }

    .command-actions > .ant-btn:not(.mobile-more-button):not(.ant-btn-primary) {
      display: none;
    }

    .mobile-more-button {
      display: inline-flex !important;
      width: 4.2rem;
      min-width: 4.2rem !important;
      padding: 0 !important;
      font-size: 2rem !important;
    }
  }
`;

export const BuilderPage = styled.div`
  .page-blocks {
    margin-bottom: 1.6rem;
  }

  .page-blocks [aria-label="Reorder page blocks"] {
    display: grid;
    gap: 1.6rem;
  }

  .ant-btn {
    min-height: 3.6rem !important;
    height: 3.6rem !important;
    padding: 0 1.4rem !important;
    border-radius: 0.8rem !important;
    font-size: 1.3rem !important;
  }

  .ant-btn-sm,
  .block-actions .ant-btn {
    min-height: 3rem !important;
    height: 3rem !important;
    padding: 0 0.8rem !important;
    border-radius: 0.7rem !important;
  }

  .block-actions .ant-btn,
  .preview-toolbar .ant-btn {
    width: 3.6rem;
    padding: 0 !important;
  }

  .block-actions .ant-btn {
    width: 3rem;
  }
`;

export const BuilderShell = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: minmax(42rem, 0.9fr) minmax(52rem, 1.1fr);
  gap: 1.6rem;
  align-items: start;

  @media (max-width: 1120px) {
    grid-template-columns: 1fr;
  }
`;

export const EditorPanel = styled.section<{$trayExpanded: boolean}>`
  min-width: 0;
  overflow: hidden;
  border-radius: 1.6rem;
  background: transparent;

  .mobile-tray-handle {
    display: none;
  }

  .ant-tabs-nav {
    margin: 0;
    padding: 1.6rem;
    border-radius: 1.6rem 1.6rem 0 0;
    background: #ffffff;
  }

  .ant-tabs-nav::before {
    border: 0;
  }

  .ant-tabs-nav-list {
    display: flex;
    width: 100%;
    overflow: hidden;
    border: 1px solid #ebebeb;
    border-radius: 0.8rem;
  }

  .ant-tabs-tab {
    display: flex;
    flex: 1;
    min-width: 0;
    justify-content: center;
    margin: 0 !important;
    padding: 0.8rem;
    border-right: 1px solid #ebebeb;
    color: #8c8c8c;
    font-size: 1.4rem;
    font-weight: 600;
  }

  .ant-tabs-tab:last-child {
    border-right: 0;
  }

  .ant-tabs-tab-active {
    background: #f5f5f5;
  }

  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #222222;
  }

  .ant-tabs-tab-active .anticon {
    color: #2bb7a9;
  }

  .public-profile-tab-icon {
    display: inline-block;
    width: 1.5rem;
    height: 1.5rem;
    flex: 0 0 auto;
    background-color: #8c8c8c;
    mask-position: center;
    mask-repeat: no-repeat;
    mask-size: contain;
    -webkit-mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-size: contain;
  }

  .public-profile-tab-icon.content-icon {
    height: 1.4rem;
    mask-image: url("/icons/public-profile-content.svg");
    -webkit-mask-image: url("/icons/public-profile-content.svg");
  }

  .public-profile-tab-icon.theme-icon {
    mask-image: url("/icons/public-profile-theme.svg");
    -webkit-mask-image: url("/icons/public-profile-theme.svg");
  }

  .public-profile-tab-icon.seo-icon {
    mask-image: url("/icons/public-profile-seo.svg");
    -webkit-mask-image: url("/icons/public-profile-seo.svg");
  }

  .ant-tabs-tab-active .public-profile-tab-icon {
    background-color: #3cb4aa;
  }

  .ant-tabs-ink-bar {
    display: none;
  }

  .tab-label {
    display: inline-flex;
    min-width: 0;
    align-items: center;
    justify-content: center;
    gap: 0.6rem;
  }

  .seo-label-short {
    display: none;
  }

  .ant-tabs-content-holder {
    max-height: calc(100vh - 24rem);
    overflow: auto;
    padding: 1.6rem;
    border-radius: 0 0 1.6rem 1.6rem;
    background: #ffffff;
    scrollbar-color: #b9b6bc transparent;
    scrollbar-width: thin;
  }

  .ant-tabs-content-holder::-webkit-scrollbar {
    width: 0.4rem;
  }

  .ant-tabs-content-holder::-webkit-scrollbar-track {
    background: transparent;
  }

  .ant-tabs-content-holder::-webkit-scrollbar-thumb {
    border-radius: 999px;
    background: #b9b6bc;
  }

  @media (max-width: 1120px) {
    .ant-tabs-content-holder {
      max-height: none;
    }
  }

  @media (max-width: 560px) {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 110;
    display: flex;
    height: ${({$trayExpanded}) => ($trayExpanded ? "calc(100dvh - 7.2rem)" : "13.2rem")};
    min-height: 0;
    flex-direction: column;
    overflow: hidden;
    border-radius: 1.6rem 1.6rem 0 0;
    background: #ffffff;
    box-shadow: 0 -0.8rem 3rem rgba(28, 23, 38, 0.12);
    transition: height 240ms cubic-bezier(0.22, 1, 0.36, 1);

    .mobile-tray-handle {
      display: grid;
      width: 100%;
      height: 3.6rem;
      min-height: 3.6rem;
      padding: 0;
      place-items: center;
      border: 0;
      background: #ffffff;
      cursor: ns-resize;
      touch-action: none;
    }

    .mobile-tray-handle span {
      width: 4.8rem;
      height: 0.5rem;
      border-radius: 999px;
      background: #bfbfbf;
    }

    .ant-tabs {
      display: flex;
      min-height: 0;
      flex: 1;
      flex-direction: column;
    }

    .ant-tabs-nav {
      flex: 0 0 auto;
      padding: 0 1.6rem 1.2rem;
    }

    .ant-tabs-tab {
      padding: 0.8rem 0.4rem;
      font-size: 1.15rem;
    }

    .tab-label {
      gap: 0.35rem;
      white-space: nowrap;
    }

    .seo-label-long {
      display: none;
    }

    .seo-label-short {
      display: inline;
    }

    .ant-tabs-content-holder {
      display: ${({$trayExpanded}) => ($trayExpanded ? "block" : "none")};
      min-height: 0;
      max-height: none;
      flex: 1;
      padding: 1.6rem 1.6rem 10rem;
      overflow-y: auto;
      border-radius: 0;
    }
  }
`;

export const SettingsCard = styled.section`
  margin-bottom: 1.6rem;
  padding: 1.6rem;
  border: 1px solid #ece9ef;
  border-radius: 1.2rem;
  background: #ffffff;

  h2 {
    margin: 0 0 0.4rem;
    color: #1c1726;
    font-size: 1.5rem;
    font-weight: 650;
  }

  > p {
    margin: 0 0 1.6rem;
    color: #817b88;
    font-size: 1.25rem;
    line-height: 1.5;
  }

  .theme-note {
    margin-top: -0.8rem;
    color: #98939e;
    font-size: 1.1rem;
    line-height: 1.45;
  }

  .ant-segmented {
    max-width: 100%;
    overflow-x: auto;
  }

  .ant-segmented-item-label {
    min-height: 3.2rem;
    padding: 0 1rem;
    line-height: 3.2rem;
    white-space: nowrap;
  }
`;

export const SeoSettingsCard = styled.section`
  padding: 0.4rem 0 2rem;
  color: #1c1726;

  .seo-field-label,
  .seo-preview-heading {
    display: flex;
    align-items: center;
    gap: 0.8rem;
    margin: 0 0 1rem;
    color: #1c1726;
    font-size: 1.4rem;
    font-weight: 400;
  }

  .seo-help-icon {
    color: #222222;
    font-size: 1.6rem;
  }

  .seo-description-field {
    margin-bottom: 3.2rem;
  }

  .seo-description-field .ant-input {
    min-height: 10rem;
    padding: 1.2rem;
    border-color: #dedce0;
    border-radius: 0.4rem;
    color: #1c1726;
    font-size: 1.35rem;
    line-height: 1.55;
    resize: vertical;
  }

  .seo-description-field .count {
    margin-top: 0.4rem;
    color: #98939e;
    font-size: 1.2rem;
    text-align: right;
  }

  .seo-preview-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1.6rem;
    margin-bottom: 2.4rem;
  }

  .seo-preview-heading {
    flex: 0 0 auto;
    margin: 0;
  }

  .seo-platforms {
    display: flex;
    overflow: hidden;
    border: 1px solid #e4e2e5;
    border-radius: 0.8rem;
    background: #fafafa;
  }

  .seo-platform {
    display: grid;
    width: 4rem;
    height: 3.8rem;
    place-items: center;
    border-right: 1px solid #e4e2e5;
    font-size: 2rem;
  }

  .seo-platform:last-child {
    border-right: 0;
  }

  .seo-platform.x {
    color: #111111;
  }

  .seo-platform.whatsapp {
    color: #35c759;
  }

  .seo-platform.linkedin {
    color: #0a66c2;
  }

  .seo-platform.facebook {
    color: #1877f2;
  }

  .seo-preview-card {
    margin-bottom: 3.2rem;
    padding: 1.6rem;
    border: 1px solid #e5e3e6;
    border-radius: 1rem;
    background: #f7f7f7;
  }

  .seo-preview-url {
    margin: 0 0 1.2rem;
    color: #2ca51c;
    font-size: 1.25rem;
    line-height: 1.4;
  }

  .seo-preview-url::after {
    display: inline-block;
    margin-left: 0.6rem;
    border-top: 0.45rem solid currentColor;
    border-right: 0.4rem solid transparent;
    border-left: 0.4rem solid transparent;
    vertical-align: middle;
    content: "";
  }

  .seo-preview-title {
    margin: 0 0 1rem;
    color: #1c1726;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1.35;
  }

  .seo-preview-description {
    margin: 0;
    color: #1c1726;
    font-size: 1.3rem;
    line-height: 1.55;
  }

  .seo-image-setting {
    display: grid;
    grid-template-columns: 12rem minmax(0, 1fr);
    gap: 1.6rem;
    align-items: start;
    margin-bottom: 3.2rem;
    padding: 0 0 3.2rem;
    border-bottom: 1px solid #e8e6e9;
  }

  .seo-image-preview {
    width: 12rem;
    aspect-ratio: 1200 / 630;
    overflow: hidden;
    border-radius: 0.2rem;
    background: #f2f2f2;
  }

  .seo-image-preview img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .seo-image-copy strong,
  .seo-image-copy span {
    display: block;
  }

  .seo-image-copy strong {
    margin-bottom: 0.4rem;
    color: #1c1726;
    font-size: 1.4rem;
    font-weight: 600;
  }

  .seo-image-copy > span {
    margin-bottom: 1.2rem;
    color: #6e6972;
    font-size: 1.25rem;
  }

  .seo-image-actions {
    display: flex;
    gap: 0.8rem;
  }

  .seo-image-actions .ant-btn {
    color: #222222 !important;
    background: #ffffff !important;
  }

  .seo-unsplash-button {
    display: inline-flex !important;
    width: 3.6rem;
    min-width: 3.6rem !important;
    align-items: center;
    justify-content: center;
    padding: 0 !important;
  }

  .seo-unsplash-button img {
    display: block;
    width: 2rem;
    height: 2rem;
    flex: 0 0 2rem;
    filter: contrast(1.2);
    object-fit: contain;
  }

  .canonical-field {
    margin-bottom: 0;
  }

  .canonical-field .ant-input-group-addon {
    padding: 0;
    background: #ffffff;
  }

  .canonical-copy-button {
    width: 4rem;
    min-width: 4rem !important;
    padding: 0 !important;
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    color: #1c1726 !important;
    background: transparent !important;
  }

  @media (max-width: 560px) {
    .seo-preview-header {
      align-items: flex-start;
      flex-direction: column;
    }

    .seo-platform {
      width: 3.7rem;
    }

    .seo-image-setting {
      grid-template-columns: 1fr;
    }
  }
`;

export const ThemeAccordion = styled.details`
  margin-bottom: 1.6rem;
  border: 1px solid #ece9ef;
  border-radius: 1.2rem;
  background: #ffffff;

  &[open] {
    border-color: #272727;
  }

  > summary {
    display: flex;
    min-height: 5.6rem;
    align-items: center;
    justify-content: space-between;
    padding: 1.6rem;
    color: #1c1726;
    font-size: 1.5rem;
    font-weight: 650;
    list-style: none;
    cursor: pointer;
  }

  > summary::-webkit-details-marker {
    display: none;
  }

  > summary::after {
    color: #77717e;
    font-size: 1.3rem;
    content: "⌄";
    transition: transform 150ms ease;
  }

  &[open] > summary::after {
    transform: rotate(180deg);
  }

  > summary:focus-visible {
    outline: 2px solid #2bb7a9;
    outline-offset: -3px;
  }

  .theme-accordion-body {
    padding: 0 1.6rem 1.6rem;
  }

  .theme-intro {
    margin: -0.8rem 0 1.6rem;
    color: #817b88;
    font-size: 1.25rem;
    line-height: 1.5;
  }

  h3 {
    margin: 2rem 0 0.6rem;
    color: #1c1726;
    font-size: 1.35rem;
    font-weight: 650;
  }

  h3 + .theme-intro {
    margin-top: 0;
  }

  .theme-note {
    margin-top: -0.8rem;
    color: #98939e;
    font-size: 1.1rem;
    line-height: 1.45;
  }

  .ant-segmented {
    max-width: 100%;
    overflow-x: auto;
  }

  .ant-segmented-item-label {
    min-height: 3.2rem;
    padding: 0 1rem;
    line-height: 3.2rem;
    white-space: nowrap;
  }
`;

export const ContentSectionCard = styled.section<{$expanded: boolean}>`
  margin-bottom: 1.6rem;
  overflow: hidden;
  border: 1px solid ${({$expanded}) => ($expanded ? "#272727" : "#ebebeb")};
  border-radius: 1.2rem;
  background: #ffffff;

  .section-toggle {
    display: flex;
    width: 100%;
    min-height: 5.6rem;
    align-items: center;
    justify-content: space-between;
    padding: 1.6rem;
    border: 0;
    background: #ffffff;
    color: #222222;
    font: inherit;
    font-size: 1.5rem;
    font-weight: 650;
    text-align: left;
    cursor: pointer;
  }

  .section-toggle:focus-visible {
    outline: 2px solid #2bb7a9;
    outline-offset: -3px;
  }

  .content-accordion-chevron {
    display: inline-block;
    color: #77717e;
    font-size: 1.3rem;
    line-height: 1;
    transition: transform 150ms ease;
  }

  .content-accordion-chevron.open {
    transform: rotate(180deg);
  }

  .footer-static-label {
    cursor: default;
  }

  .section-body {
    padding: 0 1.6rem 1.6rem;
  }

  .visibility-heading {
    margin-top: 1.8rem;
    color: #282828;
    font-size: 1.3rem;
    font-weight: 650;
  }

  .profile-source-hint {
    margin: 0.8rem 0 0;
    color: #8c8c8c;
    font-size: 1.15rem;
    line-height: 1.45;
  }
`;

export const HeaderLayoutGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.8rem;

  @media (max-width: 420px) {
    grid-template-columns: 1fr;
  }
`;

export const HeaderLayoutOption = styled.button<{$selected: boolean}>`
  padding: 0.8rem;
  border: 1.5px solid ${({$selected}) => ($selected ? "#222222" : "#e7e7e7")};
  border-radius: 1rem;
  background: #ffffff;
  color: #4a4a4a;
  font-size: 1.1rem;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
  box-shadow: ${({$selected}) =>
    $selected ? "0 0 0 0.2rem rgba(34, 34, 34, 0.08)" : "none"};

  &:focus-visible {
    outline: 2px solid #2bb7a9;
    outline-offset: 2px;
  }

  .layout-preview {
    position: relative;
    display: block;
    height: 6.4rem;
    overflow: hidden;
    margin-bottom: 0.7rem;
    border-radius: 0.6rem;
    background: #f3f3f3;
  }

  .layout-preview i {
    position: absolute;
    display: block;
  }

  .cover {
    inset: 0 0 auto;
    height: 2.2rem;
    background: #dedede;
  }

  .avatar {
    top: 1.4rem;
    left: 0.8rem;
    width: 1.8rem;
    height: 1.8rem;
    border: 0.2rem solid #ffffff;
    border-radius: 50%;
    background: #9a9a9a;
  }

  .line {
    left: 0.8rem;
    height: 0.35rem;
    border-radius: 1rem;
    background: #b8b8b8;
  }

  .line-one {
    top: 4rem;
    width: 4rem;
  }

  .line-two {
    top: 4.9rem;
    width: 5.6rem;
    background: #d0d0d0;
  }

  .basic-center .avatar {
    right: 0;
    left: 0;
    margin: auto;
  }

  .basic-center .line {
    right: 0;
    left: 0;
    margin: auto;
  }

  .full .cover {
    height: 3.2rem;
  }

  .full .avatar {
    top: 2.3rem;
  }

  .full .line-one {
    top: 4.6rem;
  }

  .full .line-two {
    top: 5.4rem;
  }
`;

export const HeaderProfileFields = styled.div`
  display: grid;
  gap: 1.6rem;

  .image-setting {
    display: grid;
    grid-template-columns: 5.6rem minmax(0, 1fr);
    align-items: center;
    gap: 1.2rem;
  }

  .profile-image-setting > img {
    width: 5.6rem;
    height: 5.6rem;
    border-radius: 50%;
    object-fit: cover;
    background: #ececec;
  }

  .cover-thumbnail {
    width: 9.6rem;
    height: 5.6rem;
    overflow: hidden;
    border-radius: 0.4rem;
    background: #f2f2f2;
  }

  .cover-image-setting {
    grid-template-columns: 9.6rem minmax(0, 1fr);
  }

  .cover-thumbnail img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .image-setting strong,
  .image-setting span {
    display: block;
  }

  .image-setting strong {
    color: #242424;
    font-size: 1.3rem;
  }

  .image-setting span {
    margin: 0.2rem 0 0.7rem;
    color: #8c8c8c;
    font-size: 1.1rem;
  }

  .image-actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.8rem;
  }

  .image-action {
    display: inline-flex;
    min-width: 0;
    height: 3rem;
    align-items: center;
    justify-content: center;
    padding: 0 0.8rem;
    border: 1px solid #ebebeb;
    border-radius: 0.7rem;
    background: #ffffff;
    border-color: #ebebeb;
    color: #222222;
    font: inherit;
    font-size: 1.3rem;
    font-weight: 400;
    line-height: 1;
    text-decoration: none;
    cursor: pointer;
    appearance: none;
  }

  .change-image-action,
  .change-image-action:link,
  .change-image-action:visited,
  .change-image-action:hover,
  .change-image-action:focus,
  .change-image-action:active {
    border-color: #ebebeb;
    background: #ffffff;
    color: #222222;
    text-decoration: none;
  }

  .remove-image-action,
  .remove-image-action:hover,
  .remove-image-action:focus,
  .remove-image-action:active {
    border-color: #ff4d4f;
    background: #ffffff;
    color: #ff4d4f;
  }

  .icon-image-action {
    width: 3rem;
    padding: 0;
  }

  .icon-image-action img {
    display: block;
    width: 2rem;
    height: 2rem;
    object-fit: contain;
  }

  .image-action:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }

  .add-social-link-action.ant-btn {
    display: inline-flex;
    width: 100%;
    height: 4rem !important;
    min-height: 4rem !important;
    align-items: center;
    justify-content: center;
    gap: 0.8rem;
    padding: 0 1.6rem !important;
    line-height: 1;
  }

  .social-links-hint + .add-social-link-action.ant-btn {
    margin-top: 1.2rem;
  }

  .social-platform-icon {
    display: inline-flex;
    min-width: 1.8rem;
    align-items: center;
    justify-content: center;
    color: #222222;
    font-size: 1.6rem;
    line-height: 1;
  }

  .add-social-link-action.ant-btn > .anticon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    line-height: 1;
  }

  .header-field-group {
    margin: 0;
  }

  .header-field-group > small {
    display: block;
    margin-top: 0.45rem;
    color: #9a9a9a;
    font-size: 1.05rem;
    line-height: 1.4;
  }

  .header-setting-row {
    padding: 0;
    border: 0;
  }

  .visibility-heading {
    margin-top: 0.2rem;
  }

  @media (max-width: 420px) {
    .cover-image-setting {
      grid-template-columns: 7.2rem minmax(0, 1fr);
    }

    .cover-thumbnail {
      width: 7.2rem;
    }
  }
`;

export const SettingRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.6rem;
  min-height: 4.4rem;
  padding: 0.8rem 0;
  border-bottom: 1px solid #f1eff3;

  &:last-child {
    border-bottom: 0;
  }

  .label {
    color: #302b37;
    font-size: 1.35rem;
  }

  .hint {
    margin-top: 0.2rem;
    color: #98939e;
    font-size: 1.15rem;
  }
`;

export const BlockRow = styled.div`
  display: grid;
  grid-template-columns: 3.6rem minmax(0, 1fr) auto;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
  padding: 1.2rem;
  border: 1px solid #e8e5eb;
  border-radius: 1rem;
  background: #fbfafc;

  .handle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3.2rem;
    height: 3.2rem;
    border-radius: 0.8rem;
    background: #f0edf3;
    color: #746e7c;
  }

  .name {
    color: #29232f;
    font-size: 1.35rem;
    font-weight: 600;
  }

  .type {
    margin-top: 0.2rem;
    color: #96909c;
    font-size: 1.1rem;
  }

  .block-actions {
    display: flex;
    align-items: center;
    gap: 0.4rem;
  }
`;

export const BlockCard = styled.section<{$expanded: boolean}>`
  margin: 0;
  overflow: hidden;
  border: 1px solid #222222;
  border-radius: 1.2rem;
  background: #ffffff;
  box-shadow: ${({$expanded}) =>
    $expanded ? "0 0 0 0.3rem rgba(107, 63, 214, 0.08)" : "none"};

  .block-header {
    display: grid;
    grid-template-columns: 3rem minmax(0, 1fr) auto;
    align-items: center;
    gap: 0.8rem;
    min-height: 5.6rem;
    padding: 1rem 1.2rem;
    position: relative;
  }

  .block-drag-handle {
    color: #8c8c8c;
    cursor: grab;
    touch-action: none;
  }

  .block-drag-handle:active {
    cursor: grabbing;
  }

  .block-toggle {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 0.8rem;
    min-width: 0;
    padding: 0;
    border: 0;
    background: transparent;
    text-align: left;
    cursor: pointer;
    outline: none;
  }

  .block-toggle:focus-visible::after {
    position: absolute;
    inset: 0.4rem;
    border: 2px solid #6b3fd6;
    border-radius: 0.9rem;
    content: "";
    pointer-events: none;
  }

  .identity {
    min-width: 0;
  }

  .identity strong,
  .identity small {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .identity strong {
    color: #29232f;
    font-size: 1.35rem;
  }

  .identity small {
    margin-top: 0.1rem;
    color: #96909c;
    font-size: 1.05rem;
  }

  .block-actions {
    display: flex;
    align-items: center;
    gap: 0.2rem;
  }

  .block-chevron-action {
    display: inline-grid;
    place-items: center;
  }

  .content-accordion-chevron {
    display: inline-block;
    color: #77717e;
    font-size: 1.3rem;
    line-height: 1;
    transition: transform 150ms ease;
  }

  .content-accordion-chevron.open {
    transform: rotate(180deg);
  }

  .block-delete-action {
    margin-left: 0.8rem;
    color: #ff4d4f;
  }

  .block-delete-action img {
    display: block;
    width: 1.6rem;
    height: 1.6rem;
    object-fit: contain;
  }

  .block-body {
    padding: 1.6rem;
    border-top: 1px solid #eeeaf0;
    background: #fcfbfd;
  }

  .block-body > .ant-alert {
    margin-bottom: 1.6rem;
  }

  .optional-label {
    color: #9a9a9a;
    font-weight: 400;
  }

  .offering-layout-options {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.8rem;
  }

  .offering-layout-option {
    display: grid;
    min-height: 9.6rem;
    padding: 1.2rem;
    border: 1px solid #ebebeb;
    border-radius: 1rem;
    background: #ffffff;
    color: #242028;
    text-align: left;
    cursor: pointer;
  }

  .offering-layout-option.selected {
    border-color: #222222;
    background: #f0edf8;
  }

  .layout-option-label {
    display: flex;
    align-items: center;
    gap: 0.8rem;
    font-size: 1.35rem;
  }

  .layout-option-label > i {
    width: 1.6rem;
    height: 1.6rem;
    border: 1px solid #cfcfcf;
    border-radius: 50%;
  }

  .selected .layout-option-label > i {
    border: 0.4rem solid #ffffff;
    background: #222222;
    box-shadow: 0 0 0 1px #222222;
  }

  .layout-option-graphic {
    display: grid;
    align-self: center;
    justify-self: center;
    gap: 0.3rem;
  }

  .layout-option-graphic.grid {
    grid-template-columns: repeat(2, 1.6rem);
  }

  .layout-option-graphic i {
    width: 1.6rem;
    height: 1.6rem;
    border: 0.2rem solid #222222;
    border-radius: 0.3rem;
  }

  .layout-option-graphic.list {
    display: block;
  }

  .layout-option-graphic.list i:first-child {
    display: block;
    width: 3.4rem;
    height: 2.8rem;
  }

  .layout-option-graphic.list i:not(:first-child) {
    display: none;
  }

  .create-offering-action.ant-btn {
    display: inline-flex;
    width: 100%;
    height: 4.4rem !important;
    min-height: 4.4rem !important;
    align-items: center;
    justify-content: center;
    gap: 0.8rem;
    background: #ffffff;
    color: #222222;
    font-weight: 600;
    line-height: 1;
  }

  .block-footer-actions {
    display: flex;
    justify-content: flex-start;
    gap: 1rem;
    margin-top: 2rem;
    padding-top: 1.6rem;
    border-top: 1px solid #ece8ef;
  }

  .inline-fields {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1rem;
  }

  .inline-fields > .ant-select,
  .inline-fields > .ant-input-number {
    width: 100%;
  }

  @media (max-width: 560px) {
    .block-toggle > .ant-tag {
      display: none;
    }

    .block-actions .ant-btn:nth-child(-n + 2) {
      display: none;
    }

    .inline-fields {
      grid-template-columns: 1fr;
    }
  }
`;

export const RepeaterItem = styled.section`
  margin-bottom: 1.2rem;
  padding: 1.2rem;
  border: 1px solid #e5e1e9;
  border-radius: 1rem;
  background: #ffffff;

  .repeater-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 1rem;
  }

  .repeater-header strong {
    color: #4a4351;
    font-size: 1.2rem;
  }
`;

export const BlockLibraryModal = styled(Modal)`
  .ant-modal-content {
    overflow: hidden;
    border-radius: 1.6rem;
    box-shadow: 0 2.4rem 6rem rgba(28, 23, 38, 0.2);
  }

  .ant-modal-header {
    margin: 0;
    padding: 1.8rem 2.4rem;
    border-bottom: 1px solid #ece8ef;
  }

  .ant-modal-title {
    color: #1c1726;
    font-size: 1.8rem;
    font-weight: 650;
    line-height: 2.4rem;
  }

  .ant-modal-close {
    width: 6rem;
    height: 6rem;
    color: #77717d;
  }

  .ant-modal-close-x {
    display: grid;
    width: 100%;
    height: 100%;
    place-items: center;
    font-size: 1.8rem;
    line-height: 1;
  }

  .ant-modal-body {
    max-height: min(72vh, 64rem);
    padding: 2.4rem;
    overflow-y: auto;
    overscroll-behavior: contain;
    scrollbar-gutter: stable;
  }

  @media (max-width: 620px) {
    width: calc(100vw - 2.4rem) !important;
    max-width: none;
    margin: 1.2rem auto;

    .ant-modal-header {
      padding: 1.6rem;
    }

    .ant-modal-close {
      width: 5.6rem;
      height: 5.6rem;
    }

    .ant-modal-body {
      max-height: calc(100dvh - 10.4rem);
      padding: 1.6rem;
    }
  }
`;

export const BlockLibraryGroup = styled.section`
  margin-bottom: 2rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const BlockLibraryGroupTitle = styled.h3`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin: 0 0 1rem;
  color: #1c1726;
  font-size: 1.5rem;
  font-weight: 650;
  line-height: 2rem;

  .group-icon {
    display: grid;
    width: 2rem;
    height: 2rem;
    place-items: center;
    color: #554c5e;
    font-size: 1.5rem;
  }
`;

export const BlockLibraryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.8rem;

  @media (max-width: 620px) {
    grid-template-columns: 1fr;
  }
`;

export const BlockLibraryButton = styled.button`
  display: grid;
  grid-template-columns: 3.6rem minmax(0, 1fr);
  align-items: center;
  gap: 1rem;
  min-height: 6.4rem;
  padding: 1rem 1.2rem;
  border: 1px solid #e5e1e9;
  border-radius: 1.2rem;
  background: #ffffff;
  text-align: left;
  cursor: pointer;
  transition: border-color 150ms ease, transform 150ms ease, box-shadow 150ms ease;

  &:hover,
  &:focus-visible {
    border-color: #6b3fd6;
    outline: none;
    box-shadow: 0 0.6rem 1.8rem rgba(62, 38, 92, 0.1);
    transform: translateY(-1px);
  }

  .icon {
    display: grid;
    width: 3.6rem;
    height: 3.6rem;
    place-items: center;
    border-radius: 0.9rem;
    background: #f1ecfb;
    color: #6b3fd6;
    font-size: 1.6rem;
  }

  .icon img {
    display: block;
    width: 2rem;
    height: 2rem;
    object-fit: contain;
  }

  strong,
  small {
    display: block;
  }

  strong {
    color: #28212f;
    font-size: 1.35rem;
    line-height: 1.8rem;
  }

  small {
    margin-top: 0.2rem;
    color: #8d8793;
    font-size: 1.1rem;
    line-height: 1.35;
  }
`;

export const ContentActions = styled.div<{$showSave: boolean}>`
  display: grid;
  grid-template-columns: ${({$showSave}) =>
    $showSave ? "auto minmax(0, 1fr)" : "minmax(0, 1fr)"};
  gap: 0.8rem;
  position: sticky;
  bottom: -1.6rem;
  z-index: 3;
  margin: 1.6rem -1.6rem -1.6rem;
  padding: 1.6rem;
  border-top: 1px solid #e8e5eb;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(1rem);

  .content-save-action.ant-btn,
  .content-save-action.ant-btn:hover,
  .content-save-action.ant-btn:focus,
  .content-save-action.ant-btn:active,
  .content-save-action.ant-btn[disabled] {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.6rem;
    background: #ffffff;
    color: #222222;
    line-height: 1;
  }

  .content-save-action img {
    display: block;
    width: 1.6rem;
    height: 1.6rem;
    object-fit: contain;
    flex: 0 0 auto;
  }

  .content-save-action > span {
    display: inline-flex;
    align-items: center;
    margin: 0;
    line-height: 1;
  }

  @media (max-width: 560px) {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 100;
    margin: 0;
    padding: 1.2rem;
    box-shadow: 0 -0.8rem 2.4rem rgba(28, 23, 38, 0.12);
  }
`;

export const ColourOverrideGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 1rem;

  .colour-input {
    display: grid;
    grid-template-columns: 4.2rem minmax(0, 1fr);
    gap: 0.8rem;
  }

  input[type="color"] {
    width: 4.2rem;
    height: 3.2rem;
    padding: 0;
    border: 0;
    border-radius: 0.4rem;
    background: transparent;
  }

  input[type="color"]::-webkit-color-swatch-wrapper {
    padding: 0;
  }

  input[type="color"]::-webkit-color-swatch {
    border: 0;
    border-radius: 0.4rem;
  }

  input[type="color"]::-moz-color-swatch {
    border: 0;
    border-radius: 0.4rem;
  }

  .colour-input .ant-input,
  .colour-input .ant-input:hover,
  .colour-input .ant-input:focus {
    border-color: #d9d9d9;
    border-radius: 0.2rem;
    background: #ffffff;
    box-shadow: none;
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

export const ValidationSummary = styled.div`
  margin-bottom: 1.6rem;

  .ant-alert-description {
    font-size: 1.2rem;
  }
`;

export const ThemeGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.8rem;

  @media (max-width: 480px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const ThemeCard = styled.button<{$selected: boolean}>`
  min-height: 10.4rem;
  padding: 0.8rem;
  border: 1px solid ${({$selected}) => ($selected ? "#272727" : "#e5e1e9")};
  border-radius: 0.8rem;
  background: #ffffff;
  text-align: left;
  cursor: pointer;
  box-shadow: ${({$selected}) =>
    $selected ? "0 0 0 0.2rem rgba(39, 39, 39, 0.08)" : "none"};

  .theme-name {
    display: flex;
    align-items: center;
    gap: 0.6rem;
  }

  strong {
    color: #27212e;
    font-size: 1.2rem;
  }

  .radio-indicator {
    display: block;
    width: 1.2rem;
    height: 1.2rem;
    border: 1px solid ${({$selected}) => ($selected ? "#272727" : "#d9d9d9")};
    border-radius: 50%;
    background: ${({$selected}) => ($selected ? "#272727" : "#ffffff")};
    box-shadow: ${({$selected}) => ($selected ? "inset 0 0 0 0.3rem #ffffff" : "none")};
  }

  .theme-orb {
    display: block;
    width: 4.8rem;
    height: 4.8rem;
    margin: 1.2rem auto 0;
    border-radius: 50%;
  }
`;

export const BackgroundStyleGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.8rem;
  margin-bottom: 1.6rem;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const BackgroundStyleCard = styled.button<{$selected: boolean}>`
  display: grid;
  min-width: 0;
  min-height: 9rem;
  align-content: space-between;
  padding: 1rem;
  border: 1px solid ${({$selected}) => ($selected ? "#272727" : "#e5e1e9")};
  border-radius: 0.8rem;
  background: #ffffff;
  color: #27212e;
  text-align: left;
  cursor: pointer;

  .background-style-label {
    display: flex;
    min-width: 0;
    align-items: center;
    gap: 0.6rem;
    font-size: 1.2rem;
    white-space: nowrap;
  }

  .radio-indicator {
    flex: 0 0 auto;
    width: 1.4rem;
    height: 1.4rem;
    border: 1px solid ${({$selected}) => ($selected ? "#272727" : "#d9d9d9")};
    border-radius: 50%;
    background: ${({$selected}) => ($selected ? "#272727" : "#ffffff")};
    box-shadow: ${({$selected}) => ($selected ? "inset 0 0 0 0.3rem #ffffff" : "none")};
  }

  .background-style-icon {
    width: 2.8rem;
    height: 2.8rem;
    align-self: end;
    justify-self: center;
    object-fit: contain;
  }
`;

export const ButtonStyleGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.8rem;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const ButtonStyleCard = styled.button<{$selected: boolean}>`
  display: grid;
  min-width: 0;
  min-height: 13rem;
  align-content: space-between;
  gap: 2rem;
  padding: 1.2rem;
  border: 1px solid ${({$selected}) => ($selected ? "#222222" : "#d9d9d9")};
  border-radius: 1rem;
  background: ${({$selected}) => ($selected ? "#f1eef9" : "#ffffff")};
  color: #1c1726;
  text-align: left;
  cursor: pointer;

  .button-style-label {
    display: inline-flex;
    align-items: center;
    gap: 0.8rem;
    font-size: 1.35rem;
  }

  .button-style-label i {
    display: block;
    flex: 0 0 auto;
    width: 1.6rem;
    height: 1.6rem;
    border: 1px solid ${({$selected}) => ($selected ? "#222222" : "#d9d9d9")};
    border-radius: 50%;
    background: ${({$selected}) => ($selected ? "#222222" : "#ffffff")};
    box-shadow: ${({$selected}) => ($selected ? "inset 0 0 0 0.35rem #ffffff" : "none")};
  }

  .button-style-preview {
    display: grid;
    width: 100%;
    min-height: 4.2rem;
    place-items: center;
    border: 2px solid #5f5f5f;
    background: #5f5f5f;
    color: #ffffff;
    font-size: 1.3rem;
    font-weight: 600;
  }

  .button-style-preview.outlined {
    background: #ffffff;
    color: #222222;
  }

  .button-style-preview.hard-shadow {
    box-shadow: 0.5rem 0.5rem 0 #000000;
  }

  .button-style-preview.glass {
    position: relative;
    overflow: hidden;
    border-color: rgba(255, 255, 255, 0.88);
    background: radial-gradient(
        circle at 18% 0%,
        rgba(255, 255, 255, 0.86),
        transparent 38%
      ),
      linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.56),
        rgba(185, 185, 185, 0.35) 48%,
        rgba(255, 255, 255, 0.48)
      );
    color: #222222;
    box-shadow: inset 0 1px 0 #ffffffeb, inset 1px 0 0 #ffffff80, inset 0 -1px 0 #ffffff57,
      0 0.6rem 1.6rem #00000014;
    backdrop-filter: blur(12px) saturate(170%);
    -webkit-backdrop-filter: blur(12px) saturate(170%);
  }

  .button-style-preview.glass::after {
    position: absolute;
    top: -90%;
    bottom: -90%;
    left: -20%;
    width: 35%;
    transform: rotate(16deg);
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.75),
      transparent
    );
    content: "";
    pointer-events: none;
  }

  &:focus-visible {
    outline: 2px solid #2bb7a9;
    outline-offset: 2px;
  }
`;

export const BlockStyleGrid = styled(ButtonStyleGrid)``;

export const BlockStyleCard = styled(ButtonStyleCard)`
  .block-style-preview {
    min-height: 4.2rem;
  }
`;

export const FieldGroup = styled.div`
  margin-bottom: 1.6rem;

  label {
    display: block;
    margin-bottom: 0.6rem;
    color: #3a3441;
    font-size: 1.25rem;
    font-weight: 400;
  }

  .count {
    margin-top: 0.4rem;
    color: #98939e;
    font-size: 1.1rem;
    text-align: right;
  }

  .field-hint {
    margin-top: 0.4rem;
    color: #98939e;
    font-size: 1.1rem;
    line-height: 1.45;
  }

  &.button-radius-field {
    margin-top: 0.8rem;
  }

  .button-radius-control {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 7.2rem auto;
    align-items: center;
    gap: 0.8rem;
  }

  .button-radius-control .ant-slider {
    min-width: 0;
    margin: 0.8rem 0.4rem;
  }

  .button-radius-control .ant-input-number {
    width: 7.2rem;
  }

  .radius-unit {
    color: #8c8c8c;
    font-size: 1.2rem;
  }

  .text-block-rich-editor {
    overflow: hidden;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    background: #ffffff;
  }

  .text-block-rich-editor .ql-toolbar.ql-snow,
  .text-block-rich-editor .ql-container.ql-snow {
    border: 0;
  }

  .text-block-rich-editor .ql-toolbar.ql-snow {
    display: flex;
    flex-wrap: wrap;
    gap: 0.2rem;
    min-height: 3.8rem;
    padding: 0.6rem 0.8rem;
    border-bottom: 1px solid #d9d9d9;
  }

  .text-block-rich-editor .ql-toolbar.ql-snow .ql-formats {
    display: inline-flex;
    align-items: center;
    margin-right: 0.4rem;
  }

  .text-block-rich-editor .ql-toolbar.ql-snow button {
    width: 2.8rem;
    height: 2.6rem;
    padding: 0.4rem;
  }

  .text-block-rich-editor .ql-container.ql-snow {
    min-height: 13.2rem;
    color: #222222;
    font-family: inherit;
    font-size: 1.25rem;
  }

  .text-block-rich-editor .ql-editor {
    min-height: 13.2rem;
    padding: 1rem 1.2rem;
    line-height: 1.55;
  }

  .text-block-rich-editor .ql-editor.ql-blank::before {
    right: 1.2rem;
    left: 1.2rem;
    color: #98939e;
    font-style: normal;
  }

  .text-block-rich-editor:focus-within {
    border-color: #222222;
  }

  .inline-action-field {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 0.8rem;
  }

  @media (max-width: 480px) {
    .inline-action-field {
      grid-template-columns: 1fr;
    }

    .inline-action-field .ant-upload,
    .inline-action-field .ant-btn {
      width: 100%;
    }
  }
`;

export const PreviewPanel = styled.aside`
  position: sticky;
  top: 0;
  min-width: 0;
  padding: 1.6rem;
  border: 1px solid #ebebeb;
  border-radius: 1.6rem;
  background: #ffffff;

  .mobile-edit-profile-button {
    display: none;
  }

  @media (max-width: 1120px) {
    position: static;
  }

  @media (max-width: 560px) {
    position: relative;
    padding: 1.6rem;
    padding-bottom: 15rem;

    .mobile-edit-profile-button {
      position: absolute;
      top: 1.2rem;
      right: 1.2rem;
      z-index: 5;
      display: inline-flex;
      width: 4.8rem;
      min-width: 4.8rem !important;
      height: 4.8rem !important;
      min-height: 4.8rem !important;
      align-items: center;
      justify-content: center;
      padding: 0 !important;
      border-radius: 50% !important;
      background: #222222;
      font-size: 2rem !important;
    }
  }
`;

export const PreviewViewport = styled.div<{$mobile: boolean}>`
  width: ${({$mobile}) => ($mobile ? "39rem" : "100%")};
  max-width: 100%;
  height: min(72rem, calc(100vh - 22rem));
  min-height: 58rem;
  overflow: hidden;
  margin: 0 auto;
  border: ${({$mobile}) => ($mobile ? "0.8rem solid #242028" : "0")};
  border-radius: ${({$mobile}) => ($mobile ? "2.8rem" : "1.2rem")};
  background: #f5f5f5;
  box-shadow: ${({$mobile}) =>
    $mobile ? "0 1.4rem 4rem rgba(28, 23, 38, 0.18)" : "none"};
  transition: width 180ms ease;

  iframe {
    width: 100%;
    height: 100%;
    border: 0;
    background: #ffffff;
  }

  @media (max-width: 560px) {
    width: 100%;
    height: calc(100dvh - 25rem);
    min-height: 55rem;
    border: 0;
    border-radius: 1.2rem;
    box-shadow: none;
  }
`;
